import React from "react";

import Area from "../../components/Area";
import Category from "../../components/Category";

import styles from "./style.module.scss";

import { Interest as db } from "../../DB";

const Introduce = () => {
  return (
    <div>
      <p className={styles.helloWorld}>Hello World</p>
      <Area title={db.title}>
        {db.contents.map((category, index) => (
          <Category
            title={category.title}
            contents={category.contents}
            key={index}
          />
        ))}
      </Area>
    </div>
  );
};

export default Introduce;
